import React, { Fragment, useState, useEffect } from 'react';
import {
  Container,
  Card,
  Typography,
  Button,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Slider,
  Switch,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Badge
} from '@material-ui/core';
import {
  Palette,
  TextFields,
  Save,
  Notifications,
  Security,
  AccountCircle,
  Speed,
  Visibility,
  VolumeUp,
  Brightness6,
  FontDownload,
  Delete,
  CloudDownload,
  CloudUpload,
  Settings,
  Lock,
  Warning,
  Info,
  Backup,
  RestoreFromTrash,
  GetApp,
  Publish,
  TouchApp,
  Keyboard,
  ScreenShare,
  Timer,
  Update,
  Build
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import '../../components/Admin/TheOilsBabe.css';
import NewNavbar from '../../new-components/NewNavbar';
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from '../../new-components/NewOverrides';
import NewDesignSystem from '../../new-components/NewDesignSystem';
import NewFooter from '../../new-components/NewFooter';
import NewMadeWith from '../../new-components/NewMadeWith';
import NewScrollTop from '../../new-components/NewScrollTop';
import { useSettings } from '../../contexts/SettingsContext';
import settingsService from '../../services/settingsService';
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'var(--background-color, #fff)',
    minHeight: '100vh',
    paddingTop: '120px', // Increased padding to avoid navbar intersection
    transition: 'background-color 0.3s ease',
  },
  heroSection: {
    backgroundColor: 'var(--surface-color, #fff)',
    color: 'var(--text-primary, #904d71)',
    padding: '40px 0',
    position: 'relative',
    overflow: 'hidden',
    marginBottom: '40px',
    border: '1px solid var(--border-color, #e7dedf)',
    borderRadius: '16px',
    boxShadow: '0 4px 20px var(--shadow-color, rgba(144, 77, 113, 0.08))',
    transition: 'all 0.3s ease',
  },
  pageTitle: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    textAlign: 'center',
    color: 'var(--text-primary, #904d71)',
    marginBottom: '16px',
  },
  pageSubtitle: {
    fontSize: '1.1rem',
    textAlign: 'center',
    opacity: 0.7,
    color: 'var(--text-secondary, #904d71)',
  },
  contentSection: {
    padding: '0 0 32px',
  },
  sectionCard: {
    borderRadius: '16px',
    boxShadow: '0 4px 20px var(--shadow-color, rgba(144, 77, 113, 0.08))',
    border: '1px solid var(--border-color, #e7dedf)',
    overflow: 'hidden',
    marginBottom: '24px',
    backgroundColor: 'var(--surface-color, #fff)',
    transition: 'all 0.3s ease',
  },
  sectionHeader: {
    padding: '24px 24px 16px',
    borderBottom: '1px solid var(--border-color, #e7dedf)',
    backgroundColor: 'var(--surface-color, white)',
    transition: 'background-color 0.3s ease, border-color 0.3s ease',
  },
  sectionTitle: {
    fontSize: '1.4rem',
    fontWeight: 'bold',
    color: 'var(--primary-color, #904d71)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  sectionContent: {
    padding: '24px',
    backgroundColor: 'var(--surface-color, white)',
    transition: 'background-color 0.3s ease',
  },
  settingItem: {
    marginBottom: '24px',
    padding: '16px',
    border: '1px solid var(--border-color, #e7dedf)',
    borderRadius: '12px',
    backgroundColor: 'var(--background-color, #fbf8f8)',
    transition: 'all 0.3s ease',
  },
  settingLabel: {
    fontSize: '1.1rem',
    fontWeight: '600',
    letterSpacing: '0.01em',
    color: 'var(--text-primary, #904d71)',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    textTransform: 'none',
  },
  settingDescription: {
    fontSize: '0.9rem',
    color: 'var(--text-secondary, #666)',
    marginBottom: '16px',
  },
  formControl: {
    minWidth: 200,
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: 'var(--input-background, rgba(255, 255, 255, 0.9))',
      backdropFilter: 'blur(10px)',
      transition: 'all 0.3s ease',
      '&:hover fieldset': {
        borderColor: '#904d71',
        boxShadow: '0 0 0 1px rgba(144, 77, 113, 0.1)',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#904d71',
        borderWidth: '2px',
        boxShadow: '0 0 0 3px rgba(144, 77, 113, 0.1)',
      },
    },
    '& .MuiInputLabel-outlined': {
      fontSize: '1rem',
      fontWeight: '500',
      letterSpacing: '0.01em',
      color: 'var(--label-color, rgba(0, 0, 0, 0.7))',
      '&.Mui-focused': {
        color: '#904d71',
        fontWeight: '600',
      },
    },
    '& .MuiSelect-select': {
      fontSize: '1rem',
      fontWeight: '400',
      letterSpacing: '0.01em',
      padding: '14px 16px',
    },
  },
  switch: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#904d71',
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#904d71',
    },
  },
  slider: {
    color: '#904d71',
    '& .MuiSlider-thumb': {
      backgroundColor: '#904d71',
    },
    '& .MuiSlider-track': {
      backgroundColor: '#904d71',
    },
    '& .MuiSlider-rail': {
      backgroundColor: '#e7dedf',
    },
  },
  saveButton: {
    backgroundColor: '#904d71',
    color: 'white',
    borderRadius: '12px',
    padding: '12px 32px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    '&:hover': {
      backgroundColor: '#6c3d51',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 20px rgba(144, 77, 113, 0.3)',
    },
  },
  previewBox: {
    padding: '16px',
    border: '1px solid var(--border-color, #e7dedf)',
    borderRadius: '12px',
    backgroundColor: 'var(--surface-color, white)',
    marginTop: '16px',
    transition: 'all 0.3s ease',
  },
}));

const SettingsPageMain = () => {
  const classes = useStyles();
  const { 
    themeMode, 
    changeThemeMode, 
    getThemeDescription,
    textSize, 
    changeTextSize,
    getEffectiveTheme 
  } = useSettings();

  // State pentru toate setările noi
  const [appearance, setAppearance] = useState({
    theme: 'light',
    fontSize: 16,
    primaryColor: '#904d71',
    secondaryColor: '#9b59b6',
    accentColor: '#e67e22'
  });

  const [notifications, setNotifications] = useState({
    emailEnabled: true,
    pushEnabled: true,
    soundEnabled: false,
    vibrationEnabled: false
  });

  const [privacy, setPrivacy] = useState({
    profileVisible: true,
    showEmail: false,
    showActivity: true,
    allowAnalytics: true
  });

  const [performance, setPerformance] = useState({
    animationsEnabled: true,
    autoplayVideos: false,
    highQualityImages: true,
    prefetchContent: false
  });

  const [accessibility, setAccessibility] = useState({
    highContrast: false,
    largeButtons: false,
    screenReader: false,
    keyboardNavigation: true
  });

  const [storageInfo, setStorageInfo] = useState({
    used: 245,
    total: 1000,
    cacheSize: 67
  });

  const [resetDialog, setResetDialog] = useState(false);
  const [exportDialog, setExportDialog] = useState(false);

  // Load settings on component mount
  useEffect(() => {
    const loadSettings = async () => {
      try {
        const userId = "user123"; // Replace with actual user ID from context
        
        const response = await fetch(`${process.env.REACT_APP_API_BASE}/settings/get?userId=${userId}`);
        
        if (response.ok) {
          const result = await response.json();
          // Handle new Firebase response format
          const data = result.data || result;
          
          if (data.appearance) setAppearance(data.appearance);
          if (data.notifications) setNotifications(data.notifications);
          if (data.privacy) setPrivacy(data.privacy);
          if (data.performance) setPerformance(data.performance);
          if (data.accessibility) setAccessibility(data.accessibility);
        }
      } catch (error) {
        console.log('Using default settings as no saved settings found');
      }
      
      // Apply saved notification preferences
      const emailNotifications = localStorage.getItem('email_notifications');
      const pushNotifications = localStorage.getItem('push_notifications');
      const soundNotifications = localStorage.getItem('sound_notifications');
      
      if (emailNotifications) {
        setNotifications(prev => ({ ...prev, emailEnabled: emailNotifications === 'true' }));
      }
      if (pushNotifications) {
        setNotifications(prev => ({ ...prev, pushEnabled: pushNotifications === 'true' }));
      }
      if (soundNotifications) {
        setNotifications(prev => ({ ...prev, soundEnabled: soundNotifications === 'true' }));
      }
      
      // Apply saved accessibility settings
      const highContrast = localStorage.getItem('accessibility_high_contrast');
      if (highContrast === 'true') {
        document.body.classList.add('high-contrast');
        setAccessibility(prev => ({ ...prev, highContrast: true }));
      }
    };

    loadSettings();
  }, []);

  const handleSaveSettings = async () => {
    try {
      const userId = "user123"; // Replace with actual user ID from context
      
      const settingsPayload = {
        userId,
        appearance,
        notifications,
        privacy,
        performance,
        accessibility
      };

      const response = await fetch(`${process.env.REACT_APP_API_BASE}/settings/post`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(settingsPayload)
      });

      if (response.ok) {
        const result = await response.json();
        // Handle new Firebase response format
        console.log('Settings saved:', result.message || 'Settings saved successfully');
        
        toast.success('Setările au fost salvate cu succes!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      } else {
        throw new Error('Eroare la salvarea setărilor');
      }
    } catch (error) {
      toast.error('Eroare la salvarea setărilor. Încercați din nou.', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
      console.error('Error saving settings:', error);
    }
  };

  const handleExportSettings = async () => {
    try {
      const userId = "user123"; // Replace with actual user ID from context
      
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/settings/export`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId })
      });

      if (response.ok) {
        const result = await response.json();
        // Handle new Firebase response format
        const data = result.data || result;
        
        // Create download link
        const dataStr = JSON.stringify(data, null, 2);
        const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
        
        const exportFileDefaultName = result.filename || 'theoilsbabe-settings.json';
        
        const linkElement = document.createElement('a');
        linkElement.setAttribute('href', dataUri);
        linkElement.setAttribute('download', exportFileDefaultName);
        linkElement.click();

        toast.success('Setările au fost exportate cu succes!', {
          position: 'top-right',
          autoClose: 3000,
        });

        setExportDialog(false);
      } else {
        throw new Error('Eroare la exportul setărilor');
      }
    } catch (error) {
      toast.error('Eroare la exportul setărilor. Încercați din nou.', {
        position: 'top-right',
        autoClose: 5000,
      });
      console.error('Error exporting settings:', error);
    }
  };

  const handleImportSettings = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const text = await file.text();
      const settingsData = JSON.parse(text);
      const userId = "user123"; // Replace with actual user ID from context
      
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/settings/import`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId, settingsData })
      });

      if (response.ok) {
        const result = await response.json();
        // Handle new Firebase response format
        const data = result.data || result;
        
        // Update local state with imported settings
        if (data.appearance) setAppearance(data.appearance);
        if (data.notifications) setNotifications(data.notifications);
        if (data.privacy) setPrivacy(data.privacy);
        if (data.performance) setPerformance(data.performance);
        if (data.accessibility) setAccessibility(data.accessibility);

        toast.success('Setările au fost importate cu succes!', {
          position: 'top-right',
          autoClose: 3000,
        });
      } else {
        throw new Error('Eroare la importul setărilor');
      }
    } catch (error) {
      toast.error('Eroare la importul setărilor. Verificați fișierul și încercați din nou.', {
        position: 'top-right',
        autoClose: 5000,
      });
      console.error('Error importing settings:', error);
    }
    
    // Reset file input
    event.target.value = '';
  };

  const handleResetSettings = () => {
    // Reset all settings to defaults
    setAppearance({
      theme: 'light',
      fontSize: 16,
      primaryColor: '#904d71',
      secondaryColor: '#9b59b6',
      accentColor: '#e67e22'
    });
    
    setNotifications({
      emailEnabled: true,
      pushEnabled: true,
      soundEnabled: false,
      vibrationEnabled: false
    });
    
    setPrivacy({
      profileVisible: true,
      showEmail: false,
      showActivity: true,
      allowAnalytics: true
    });
    
    setPerformance({
      animationsEnabled: true,
      autoplayVideos: false,
      highQualityImages: true,
      prefetchContent: false
    });
    
    setAccessibility({
      highContrast: false,
      largeButtons: false,
      screenReader: false,
      keyboardNavigation: true
    });

    setResetDialog(false);
    
    toast.success('Toate setările au fost resetate la valorile implicite!', {
      position: 'top-right',
      autoClose: 3000,
    });
  };

  const handleClearCache = () => {
    // Clear application cache
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    
    // Clear localStorage
    localStorage.clear();
    
    // Update storage info
    setStorageInfo(prev => ({
      ...prev,
      cacheSize: 0
    }));

    toast.success('Cache-ul a fost șters cu succes!', {
      position: 'top-right',
      autoClose: 3000,
    });
  };

  const handleNotificationChange = (type) => (event) => {
    setNotifications(prev => ({
      ...prev,
      [type]: event.target.checked
    }));
    
    // Apply real-time notification functionality
    if (type === 'emailEnabled') {
      // Update email notification settings
      localStorage.setItem('email_notifications', event.target.checked);
      
      // Show confirmation toast
      toast.info(event.target.checked ? 
        'Notificările prin email au fost activate' : 
        'Notificările prin email au fost dezactivate', {
        position: 'top-right',
        autoClose: 2000,
      });
    } else if (type === 'pushEnabled') {
      // Request notification permission if enabling
      if (event.target.checked && 'Notification' in window) {
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            // Test notification
            new Notification('TheOilsBabe', {
              body: 'Notificările push au fost activate cu succes!',
              icon: '/favicon.ico',
              badge: '/favicon.ico'
            });
            
            localStorage.setItem('push_notifications', 'true');
            
            // Register service worker for push notifications if available
            if ('serviceWorker' in navigator) {
              navigator.serviceWorker.ready.then(registration => {
                console.log('Service Worker ready for push notifications');
              });
            }
          } else {
            setNotifications(prev => ({ ...prev, pushEnabled: false }));
            toast.error('Permisiunea pentru notificări a fost refuzată');
          }
        });
      } else if (!event.target.checked) {
        localStorage.setItem('push_notifications', 'false');
        toast.info('Notificările push au fost dezactivate');
      }
    } else if (type === 'soundEnabled') {
      localStorage.setItem('sound_notifications', event.target.checked);
      
      // Test sound if enabling
      if (event.target.checked) {
        // Create a simple notification sound
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);
        
        oscillator.frequency.value = 800;
        oscillator.type = 'sine';
        
        gainNode.gain.setValueAtTime(0, audioContext.currentTime);
        gainNode.gain.linearRampToValueAtTime(0.1, audioContext.currentTime + 0.1);
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
        
        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.5);
        
        toast.success('Sunetele pentru notificări au fost activate');
      } else {
        toast.info('Sunetele pentru notificări au fost dezactivate');
      }
    } else if (type === 'vibrationEnabled') {
      localStorage.setItem('vibration_notifications', event.target.checked);
      
      // Test vibration if enabling (mobile devices)
      if (event.target.checked && 'vibrate' in navigator) {
        navigator.vibrate([100, 50, 100]);
        toast.success('Vibrațiile pentru notificări au fost activate');
      } else {
        toast.info('Vibrațiile pentru notificări au fost dezactivate');
      }
    }
  };

  const handlePrivacyChange = (type) => (event) => {
    setPrivacy(prev => ({
      ...prev,
      [type]: event.target.checked
    }));
    
    // Apply real-time functionality
    if (type === 'profileVisible') {
      document.body.setAttribute('data-profile-visible', event.target.checked);
    } else if (type === 'allowAnalytics') {
      // Toggle analytics
      if (event.target.checked) {
        localStorage.setItem('analytics_enabled', 'true');
      } else {
        localStorage.setItem('analytics_enabled', 'false');
      }
    }
  };

  const handlePerformanceChange = (type) => (event) => {
    setPerformance(prev => ({
      ...prev,
      [type]: event.target.checked
    }));
    
    // Apply real-time performance optimizations
    if (type === 'animationsEnabled') {
      document.body.setAttribute('data-animations', event.target.checked ? 'enabled' : 'disabled');
      
      if (event.target.checked) {
        document.documentElement.style.setProperty('--animation-duration', '0.3s');
        document.documentElement.style.setProperty('--transition-duration', '0.2s');
        document.body.classList.remove('no-animations');
      } else {
        document.documentElement.style.setProperty('--animation-duration', '0s');
        document.documentElement.style.setProperty('--transition-duration', '0s');
        document.body.classList.add('no-animations');
      }
      
      localStorage.setItem('animations_enabled', event.target.checked);
      
      toast.info(event.target.checked ? 
        'Animațiile au fost activate' : 
        'Animațiile au fost dezactivate', {
        position: 'top-right',
        autoClose: 2000,
      });
    } else if (type === 'autoplayVideos') {
      // Set autoplay preference for all videos
      const videos = document.querySelectorAll('video');
      videos.forEach(video => {
        if (event.target.checked) {
          video.setAttribute('autoplay', '');
          video.setAttribute('muted', ''); // Required for autoplay in most browsers
        } else {
          video.removeAttribute('autoplay');
        }
      });
      
      // Set up observer for future videos
      if (event.target.checked) {
        const videoObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                const videos = node.querySelectorAll ? node.querySelectorAll('video') : [];
                videos.forEach(video => {
                  video.setAttribute('autoplay', '');
                  video.setAttribute('muted', '');
                });
              }
            });
          });
        });
        videoObserver.observe(document.body, { childList: true, subtree: true });
        window._videoObserver = videoObserver;
      } else if (window._videoObserver) {
        window._videoObserver.disconnect();
      }
      
      localStorage.setItem('autoplay_videos', event.target.checked);
      
      toast.info(event.target.checked ? 
        'Redarea automată a video-urilor a fost activată' : 
        'Redarea automată a video-urilor a fost dezactivată');
        
    } else if (type === 'highQualityImages') {
      document.body.setAttribute('data-image-quality', event.target.checked ? 'high' : 'normal');
      
      // Apply image quality settings
      const images = document.querySelectorAll('img');
      images.forEach(img => {
        if (event.target.checked) {
          img.style.imageRendering = 'high-quality';
          // Load high-res versions if available
          const srcset = img.getAttribute('data-srcset-hq');
          if (srcset) {
            img.setAttribute('srcset', srcset);
          }
        } else {
          img.style.imageRendering = 'auto';
          // Load standard versions
          const srcset = img.getAttribute('data-srcset-std');
          if (srcset) {
            img.setAttribute('srcset', srcset);
          }
        }
      });
      
      localStorage.setItem('high_quality_images', event.target.checked);
      
      toast.info(event.target.checked ? 
        'Imagini de înaltă calitate activate' : 
        'Imagini de calitate standard activate');
        
    } else if (type === 'prefetchContent') {
      localStorage.setItem('prefetch_content', event.target.checked);
      
      if (event.target.checked) {
        // Enable DNS prefetch and preconnect for common domains
        const prefetchDomains = [
          'fonts.googleapis.com',
          'fonts.gstatic.com',
          'api.theoilsbabe.com'
        ];
        
        prefetchDomains.forEach(domain => {
          const link = document.createElement('link');
          link.rel = 'dns-prefetch';
          link.href = `//${domain}`;
          document.head.appendChild(link);
          
          const preconnectLink = document.createElement('link');
          preconnectLink.rel = 'preconnect';
          preconnectLink.href = `https://${domain}`;
          document.head.appendChild(preconnectLink);
        });
        
        // Prefetch critical resources
        const criticalResources = document.querySelectorAll('link[rel="preload"], link[rel="prefetch"]');
        criticalResources.forEach(resource => {
          if (!resource.hasAttribute('data-prefetched')) {
            resource.setAttribute('data-prefetched', 'true');
          }
        });
        
        toast.success('Preîncărcarea conținutului a fost activată');
      } else {
        // Remove prefetch links
        const prefetchLinks = document.querySelectorAll('link[rel="dns-prefetch"], link[rel="preconnect"]');
        prefetchLinks.forEach(link => link.remove());
        
        toast.info('Preîncărcarea conținutului a fost dezactivată');
      }
    }
  };

  const handleAccessibilityChange = (type) => (event) => {
    setAccessibility(prev => ({
      ...prev,
      [type]: event.target.checked
    }));
    
    // Apply real-time accessibility changes
    if (type === 'highContrast') {
      document.body.classList.toggle('high-contrast', event.target.checked);
      document.documentElement.style.setProperty('--contrast-mode', event.target.checked ? 'high' : 'normal');
    } else if (type === 'largeButtons') {
      document.body.classList.toggle('large-buttons', event.target.checked);
      document.documentElement.style.setProperty('--button-scale', event.target.checked ? '1.2' : '1');
    } else if (type === 'screenReader') {
      document.body.setAttribute('data-screen-reader', event.target.checked);
      // Add aria-live regions for screen readers
      if (event.target.checked) {
        const liveRegion = document.createElement('div');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('id', 'screen-reader-announcements');
        liveRegion.style.position = 'absolute';
        liveRegion.style.left = '-10000px';
        document.body.appendChild(liveRegion);
      }
    } else if (type === 'keyboardNavigation') {
      document.body.setAttribute('data-keyboard-nav', event.target.checked);
      // Enable focus-visible styles
      if (event.target.checked) {
        document.documentElement.classList.add('keyboard-navigation');
      } else {
        document.documentElement.classList.remove('keyboard-navigation');
      }
    }
  };

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader />
      <Box className={classes.root}>
        <Container maxWidth="lg">
          {/* Settings Header */}
          <div className={classes.heroSection}>
            <Container>
              <Typography className={classes.pageTitle}>
                ⚙️ Setări Avansate
              </Typography>
              <Typography className={classes.pageSubtitle}>
                Personalizează experiența ta pe TheOilsBabe cu setări detaliate și funcționalități avansate
              </Typography>
            </Container>
          </div>

          <div className={classes.contentSection}>

            {/* Aparență și temă */}
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  <Palette />
                  Aparență și Personalizare
                </Typography>
              </div>
              <div className={classes.sectionContent}>
                <div className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    <Brightness6 />
                    Tema aplicației
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    {getThemeDescription()}
                  </Typography>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel>Selectează tema</InputLabel>
                    <Select
                      value={themeMode}
                      onChange={(e) => changeThemeMode(e.target.value)}
                      label="Selectează tema"
                    >
                      <MenuItem value="auto">Automat (sistemul)</MenuItem>
                      <MenuItem value="light">Luminos</MenuItem>
                      <MenuItem value="dark">Întunecat</MenuItem>
                    </Select>
                  </FormControl>
                  
                  <div className={classes.previewBox}>
                    <Typography variant="body2" style={{ marginBottom: '8px', fontWeight: 'bold' }}>
                      Previzualizare temă:
                    </Typography>
                    <Box 
                      style={{ 
                        padding: '12px', 
                        backgroundColor: getEffectiveTheme() === 'dark' ? '#2c2c2c' : '#ffffff',
                        color: getEffectiveTheme() === 'dark' ? '#ffffff' : '#333333',
                        border: '1px solid #e7dedf',
                        borderRadius: '8px'
                      }}
                    >
                      Acesta este un exemplu de text în tema selectată. Interfața va arăta așa.
                    </Box>
                  </div>
                </div>

              </div>
            </Card>

            {/* Text și font */}
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  <TextFields />
                  Text și Afișare
                </Typography>
              </div>
              <div className={classes.sectionContent}>
                <div className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    <FontDownload />
                    Mărimea textului
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    Ajustează mărimea textului pentru o citire confortabilă
                  </Typography>
                  
                  <Box style={{ margin: '16px 0' }}>
                    <Typography gutterBottom>
                      Mărime curentă: {textSize}px
                    </Typography>
                    <Slider
                      value={textSize}
                      onChange={(e, newValue) => changeTextSize(newValue)}
                      min={12}
                      max={24}
                      step={1}
                      marks={[
                        { value: 12, label: 'Mic' },
                        { value: 16, label: 'Normal' },
                        { value: 20, label: 'Mare' },
                        { value: 24, label: 'Extra Mare' }
                      ]}
                      className={classes.slider}
                    />
                  </Box>
                  
                  <div className={classes.previewBox}>
                    <Typography variant="body2" style={{ marginBottom: '8px', fontWeight: 'bold' }}>
                      Previzualizare text:
                    </Typography>
                    <Typography style={{ fontSize: `${textSize}px` }}>
                      Acesta este un exemplu de text cu mărimea selectată. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </Typography>
                  </div>
                </div>
              </div>
            </Card>

            {/* Notificări */}
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  <Notifications />
                  Notificări și Alerte
                </Typography>
              </div>
              <div className={classes.sectionContent}>
                <div className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    <Badge color="secondary" badgeContent={Object.values(notifications).filter(Boolean).length}>
                      <Notifications />
                    </Badge>
                    Preferințe notificări
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    Controlează ce notificări dorești să primești
                  </Typography>

                  <List>
                    <ListItem>
                      <ListItemIcon><Notifications /></ListItemIcon>
                      <ListItemText primary="Notificări email" secondary="Primește notificări prin email" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={notifications.email}
                          onChange={handleNotificationChange('email')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><TouchApp /></ListItemIcon>
                      <ListItemText primary="Notificări push" secondary="Notificări în browser" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={notifications.push}
                          onChange={handleNotificationChange('push')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><ScreenShare /></ListItemIcon>
                      <ListItemText primary="Notificări desktop" secondary="Notificări pe desktop" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={notifications.desktop}
                          onChange={handleNotificationChange('desktop')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><Info /></ListItemIcon>
                      <ListItemText primary="Marketing și oferte" secondary="Informații despre produse și oferte" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={notifications.marketing}
                          onChange={handleNotificationChange('marketing')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><Update /></ListItemIcon>
                      <ListItemText primary="Actualizări aplicație" secondary="Notificări despre actualizări" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={notifications.updates}
                          onChange={handleNotificationChange('updates')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </div>
              </div>
            </Card>

            {/* Confidențialitate și securitate */}
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  <Security />
                  Confidențialitate și Securitate
                </Typography>
              </div>
              <div className={classes.sectionContent}>
                <div className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    <Lock />
                    Setări confidențialitate
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    Controlează ce informații sunt vizibile pentru alții
                  </Typography>

                  <List>
                    <ListItem>
                      <ListItemIcon><AccountCircle /></ListItemIcon>
                      <ListItemText primary="Profil vizibil" secondary="Profilul tău poate fi vizualizat de alți utilizatori" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={privacy.profileVisible}
                          onChange={handlePrivacyChange('profileVisible')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><Info /></ListItemIcon>
                      <ListItemText primary="Arată email-ul" secondary="Adresa de email este vizibilă în profil" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={privacy.showEmail}
                          onChange={handlePrivacyChange('showEmail')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><Timer /></ListItemIcon>
                      <ListItemText primary="Arată activitatea" secondary="Ultima activitate este vizibilă" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={privacy.showActivity}
                          onChange={handlePrivacyChange('showActivity')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><Build /></ListItemIcon>
                      <ListItemText primary="Permite analiză" secondary="Ajută-ne să îmbunătățim aplicația" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={privacy.allowAnalytics}
                          onChange={handlePrivacyChange('allowAnalytics')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </div>
              </div>
            </Card>

            {/* Performanță și viteză */}
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  <Speed />
                  Performanță și Optimizare
                </Typography>
              </div>
              <div className={classes.sectionContent}>
                <div className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    <Build />
                    Setări performanță
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    Optimizează viteza și fluiditatea aplicației
                  </Typography>

                  <List>
                    <ListItem>
                      <ListItemIcon><Settings /></ListItemIcon>
                      <ListItemText primary="Animații activate" secondary="Efecte vizuale și animații" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={performance.animationsEnabled}
                          onChange={handlePerformanceChange('animationsEnabled')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><VolumeUp /></ListItemIcon>
                      <ListItemText primary="Autoplay videouri" secondary="Videoclipurile pornesc automat" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={performance.autoplayVideos}
                          onChange={handlePerformanceChange('autoplayVideos')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><Visibility /></ListItemIcon>
                      <ListItemText primary="Imagini înaltă calitate" secondary="Încarcă imagini în calitate maximă" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={performance.highQualityImages}
                          onChange={handlePerformanceChange('highQualityImages')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><CloudDownload /></ListItemIcon>
                      <ListItemText primary="Preîncarcă conținut" secondary="Încarcă conținutul în avans pentru viteză" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={performance.prefetchContent}
                          onChange={handlePerformanceChange('prefetchContent')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </div>
              </div>
            </Card>

            {/* Accesibilitate */}
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  <TouchApp />
                  Accesibilitate și Ușurință în Utilizare
                </Typography>
              </div>
              <div className={classes.sectionContent}>
                <div className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    <TouchApp />
                    Opțiuni accesibilitate
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    Setări pentru o experiență mai accesibilă
                  </Typography>

                  <List>
                    <ListItem>
                      <ListItemIcon><Visibility /></ListItemIcon>
                      <ListItemText primary="Contrast înalt" secondary="Mărește contrastul pentru vizibilitate mai bună" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={accessibility.highContrast}
                          onChange={handleAccessibilityChange('highContrast')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><TouchApp /></ListItemIcon>
                      <ListItemText primary="Butoane mari" secondary="Mărește mărimea butoanelor pentru atingere ușoară" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={accessibility.largeButtons}
                          onChange={handleAccessibilityChange('largeButtons')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><VolumeUp /></ListItemIcon>
                      <ListItemText primary="Suport cititor ecran" secondary="Optimizează pentru tehnologii asistive" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={accessibility.screenReader}
                          onChange={handleAccessibilityChange('screenReader')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemIcon><Keyboard /></ListItemIcon>
                      <ListItemText primary="Navigare cu tastatura" secondary="Permite navigarea completă cu tastatura" />
                      <ListItemSecondaryAction>
                        <Switch
                          className={classes.switchControl}
                          checked={accessibility.keyboardNavigation}
                          onChange={handleAccessibilityChange('keyboardNavigation')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </div>
              </div>
            </Card>

            {/* Backup și Export/Import */}
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  <Backup />
                  Backup și Gestionare Date
                </Typography>
              </div>
              <div className={classes.sectionContent}>
                <div className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    <CloudUpload />
                    Export și Import setări
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    Salvează setările tale sau importă setări salvate anterior
                  </Typography>

                  <Box display="flex" gap="16px" flexWrap="wrap" style={{ marginTop: '16px' }}>
                    <Button
                      variant="outlined"
                      startIcon={<GetApp />}
                      onClick={() => setExportDialog(true)}
                      style={{ borderColor: '#904d71', color: '#904d71' }}
                    >
                      Exportă Setările
                    </Button>
                    
                    <input
                      type="file"
                      accept=".json"
                      onChange={handleImportSettings}
                      style={{ display: 'none' }}
                      id="import-settings"
                    />
                    <label htmlFor="import-settings">
                      <Button
                        variant="outlined"
                        component="span"
                        startIcon={<Publish />}
                        style={{ borderColor: '#904d71', color: '#904d71' }}
                      >
                        Importă Setările
                      </Button>
                    </label>

                    <Button
                      variant="outlined"
                      startIcon={<Delete />}
                      onClick={handleClearCache}
                      style={{ borderColor: '#f57c00', color: '#f57c00' }}
                    >
                      Șterge Cache ({storageInfo.cacheSize} MB)
                    </Button>

                    <Button
                      variant="outlined"
                      startIcon={<RestoreFromTrash />}
                      onClick={() => setResetDialog(true)}
                      style={{ borderColor: '#d32f2f', color: '#d32f2f' }}
                    >
                      Resetează Toate
                    </Button>
                  </Box>
                </div>
              </div>
            </Card>

            {/* Save Settings Button */}
            <Box display="flex" justifyContent="center" mt={4}>
              <Button
                onClick={handleSaveSettings}
                className={classes.saveButton}
                startIcon={<Save />}
                size="large"
              >
                Salvează Toate Setările
              </Button>
            </Box>
          </div>
        </Container>
      </Box>

      {/* Dialog pentru export setări */}
      <Dialog open={exportDialog} onClose={() => setExportDialog(false)}>
        <DialogTitle>Exportă Setările</DialogTitle>
        <DialogContent>
          <Typography>
            Dorești să exporți toate setările curente într-un fișier JSON? 
            Acesta poate fi folosit pentru a importa setările pe alte dispozitive.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setExportDialog(false)}>Anulează</Button>
          <Button onClick={handleExportSettings} color="primary">
            Exportă
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog pentru reset setări */}
      <Dialog open={resetDialog} onClose={() => setResetDialog(false)}>
        <DialogTitle>
          <Warning color="error" style={{ verticalAlign: 'middle', marginRight: 8 }} />
          Resetează Toate Setările
        </DialogTitle>
        <DialogContent>
          <Typography>
            Această acțiune va reseta toate setările la valorile implicite. 
            <strong>Această acțiune nu poate fi anulată.</strong>
          </Typography>
          <Typography style={{ marginTop: '16px', color: '#666' }}>
            Setările care vor fi resetate:
          </Typography>
          <ul style={{ color: '#666', marginTop: '8px' }}>
            <li>Tema și culori</li>
            <li>Mărimea textului</li>
            <li>Preferințe notificări</li>
            <li>Setări confidențialitate</li>
            <li>Opțiuni performanță</li>
            <li>Setări accesibilitate</li>
            <li>Opțiuni avansate</li>
          </ul>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setResetDialog(false)}>Anulează</Button>
          <Button onClick={handleResetSettings} color="secondary">
            Resetează Toate
          </Button>
        </DialogActions>
      </Dialog>

      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};

export default SettingsPageMain;
